import backend from "../../utils/backend";
import qs from "qs";
import { GET_SUBSCRIPTIONS, GET_SUBSCRIPTIONS_SUCCESS, GET_SUBSCRIPTIONS_ERROR, GET_SUBSCRIPTION, GET_SUBSCRIPTION_SUCCESS, GET_SUBSCRIPTION_ERROR, GET_SUBSCRIPTION_NEWSLETTERS, GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS, GET_SUBSCRIPTION_NEWSLETTERS_ERROR, GET_NEWSLETTER, GET_NEWSLETTER_SUCCESS, GET_NEWSLETTER_ERROR } from "../../constants/actionTypes";
import { BACKEND_ROOT } from "config/constants";

export var getSubscriptions = function getSubscriptions(params) {
  return function (dispatch) {
    dispatch({
      type: GET_SUBSCRIPTIONS
    });

    return backend.request({
      method: "GET",
      url: "/subscriptions/?" + qs.stringify(params)

    }).then(function (response) {
      dispatch({
        type: GET_SUBSCRIPTIONS_SUCCESS,
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: GET_SUBSCRIPTIONS_ERROR,
        payload: err
      });
    });
  };
};

export var getNewsletter = function getNewsletter(newsletterId, token, revision) {
  return function (dispatch) {
    dispatch({
      type: GET_NEWSLETTER
    });

    return backend.request({
      method: "GET",
      url: token ? BACKEND_ROOT + "/api/newsletters/" + newsletterId + "/" + (revision ? "revisions/" + revision + "/" : "") : "/newsletters/" + newsletterId + "/",
      headers: {
        "Authorization": token ? "Bearer " + token : undefined
      }
    }).then(function (response) {
      dispatch({
        type: GET_NEWSLETTER_SUCCESS,
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: GET_NEWSLETTER_ERROR,
        payload: err
      });
    });
  };
};

export var populateSubscription = function populateSubscription(subscriptionId) {
  return function (dispatch) {
    return dispatch(getSubscription(subscriptionId)).then(dispatch(getSubscriptionNewsletters(subscriptionId)));
  };
};

export var getSubscription = function getSubscription(subscriptionId) {
  return function (dispatch) {
    dispatch({
      type: GET_SUBSCRIPTION
    });

    return backend.request({
      method: "GET",
      url: "/subscriptions/" + subscriptionId + "/"
    }).then(function (response) {
      dispatch({
        type: GET_SUBSCRIPTION_SUCCESS,
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: GET_SUBSCRIPTION_ERROR,
        payload: err
      });
    });
  };
};

export var getSubscriptionNewsletters = function getSubscriptionNewsletters(subscriptionId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return function (dispatch) {
    dispatch({
      type: GET_SUBSCRIPTION_NEWSLETTERS
    });

    return backend.request({
      method: "GET",
      url: "/subscriptions/" + subscriptionId + "/newsletters/",
      params: { page: page }
    }).then(function (response) {
      dispatch({
        type: GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS,
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: GET_SUBSCRIPTION_NEWSLETTERS_ERROR,
        payload: err
      });
    });
  };
};


// WEBPACK FOOTER //
// ./src/subscriptions/actions/subscriptions.js